import Service from './service';

export const BannerServices = () => {
    return Service.Get('/banner?_format=json');
}

export const categories = () => {
    return Service.Get('/term/categories?_format=json');
}

export const HomeService = (retailerId) => {
    return Service.Get('/home/' + retailerId+'?_format=json');
}
